import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Repo from "../../Repository/Repo";

const initialState = {
  loading: false,
  invoices: [],
  saleInvoices: [],
  purchaseInvoices: [],
  oldInvoices: [],
  invoiceNumber: 0,
  error: "",
};

export const getInvoices = createAsyncThunk("invoice/fetchInvoice", () => {
  return Repo.invoice({
    request: {
      method: "getSalesPurchaseinvoices",
      data: {
        company_code: localStorage.getItem("companyCode"),
      },
    },
  })
    .then(({ data }) => data.response.data)
    .catch((err) => console.log(err));
});

export const invoiceSlice = createSlice({
  name: "addInvoice",
  initialState,
  reducers: {
    invoiceAdded: (state, action) => {
      state.invoices.unshift(action.payload);
    },
    removeInvoice: (state, action) => {
      const { id } = action.payload;
      let foundIndex = state.invoices.findIndex((item) => item._id == id);
      state.invoices.splice(foundIndex, 1);
    },
    removebyIndex: (state, action) => {
      let { index } = action.payload;
      state.invoices.splice(index, 1);
    },
    increaseInvoiceNo: (state, action) => {
      state.invoiceNumber += 1;
    },
    decreaseInvoiceNo: (state, action) => {
      if (state.invoiceNumber > 0) {
        state.invoiceNumber -= 1;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getInvoices.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getInvoices.fulfilled, (state, action) => {
      let arr = action.payload;
      console.log("action.payload:", action.payload);
      state.loading = false;
      if (action.payload?.sales) {
        state.saleInvoices = action.payload.sales;
      }
      if (action.payload?.purchase) {
        state.purchaseInvoices = action.payload.purchase;
      }
      if (action.payload?.others) {
        state.oldInvoices = action.payload.others;
      }

      // state.invoices = action.payload;
      // if (arr?.length > 0) {
      //   if (arr[0].invoiceNumber) {
      //     state.invoiceNumber = arr[0].invoiceNumber;
      //   } else {
      //     state.invoiceNumber = arr.length;
      //   }
      // } else {
      //   state.invoiceNumber = 0;
      // }
      state.error = "";
    });
    builder.addCase(getInvoices.rejected, (state, action) => {
      state.loading = false;
      state.invoices = [];
      state.error = action.error.message;
    });
  },
});

export const {
  increaseInvoiceNo,
  decreaseInvoiceNo,
  invoiceAdded,
  removeInvoice,
  removebyIndex,
} = invoiceSlice.actions;

export default invoiceSlice.reducer;
